import { Box, TextField, useMediaQuery } from "@mui/material";
import React, { useEffect } from "react";
import { useState } from "react"

type DateFieldProps = {
    value: number | undefined,
    label: string,
    handleChange: (value: number) => void,
}

const DateField = (props: DateFieldProps) => {
    const [ stringValue, setStringValue ] = useState('-');
    const isSmall = useMediaQuery('(max-width:1000px)');

    useEffect(() => {        
        const s = props?.value !== undefined && props.value > 0 ? props.value.toString() : '-';
        setStringValue(s);
    }, [props]);

    const handleValueChange = (e: string) => {
        setStringValue(e);
        props.handleChange(isNaN(parseInt(e)) ? -1 : parseInt(e));
    }
        
    return (
        <Box>
            <TextField
                sx={{ width: isSmall ? '80px' : '80px' }}
                size="small"
                label={props.label}
                variant="outlined"
                value={stringValue}
                slotProps={{inputLabel: { shrink: true } }}
                onChange={(e) => handleValueChange(e.target.value)}
            />
        </Box>
    );
}

export default DateField;